export var AuditLogAuthStatus;
(function (AuditLogAuthStatus) {
    AuditLogAuthStatus["Success"] = "SUCCESS";
    AuditLogAuthStatus["Failure"] = "FAILURE";
})(AuditLogAuthStatus || (AuditLogAuthStatus = {}));
